module.exports = __webpack_public_path__ + "img/panasonic_001.12b4012d.jpg";